<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file MainNavigationAuth.vue is part of event_pass_client.dev.        -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - MainNavigationAuth.vue can not be copied and/or distributed               -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.--><!--//User: keni--><!--//Date: 06/03/2018--><!--//Time: 15:23-->

<template>
    <div>
        <main-navigation-user-links :user="user" :route="route"/>
    </div>

</template>

<script>

    Vue.component('main-navigation-user-links',require('./MainNavigationUserLinks'));
	export default {
		name: "main-navigation-auth",
		components: {},
		props: ['route','user'],

		created() {
		},
		destroyed() {
		},
		mounted() {
// console.log('auth',this);
		},
		data() {
			return {}
		},
		methods: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/nav/MainNavigationAuth.vue